// src/components/Navbar.jsx
import React, { useState } from "react";
import "../assets/css/Navbar.css";
import logo from '../assets/am-logo/am-logo.png';

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [showLogin, setShowLogin] = useState(false);

  return (
    <>
      <nav className="navbar">
        <div className="logo"> <img src={logo} alt="AabhyasMitra Logo"></img> </div>

        <div className={`nav-links ${menuOpen ? "active" : ""}`}>
          <a href="#home">Home</a>
          <a href="#about">About</a>
          <a href="#franchise">Franchise</a>
          <a href="#counsellor">Counsellor</a>
          <a href="#student">Student</a>
          <a href="#faq">FAQ</a>
          <a href="#contact">Contact</a>
          <button className="login-btn" onClick={() => setShowLogin(true)}>
            Login
          </button>
        </div>

        <div
          className={`hamburger ${menuOpen ? "open" : ""}`}
          onClick={() => setMenuOpen(!menuOpen)}
        >
          <span></span>
          <span></span>
          <span></span>
        </div>
      </nav>

      {showLogin && (
        <div className="modal-overlay" onClick={() => setShowLogin(false)}>
          <div className="modal" onClick={(e) => e.stopPropagation()}>
            <h2>Login</h2>
            <form>
              <label>Email / ID</label>
              <input type="text" placeholder="Enter your ID" required />
              <label>Password</label>
              <input type="password" placeholder="Enter Password" required />
              <button type="submit" className="submit-btn">Login</button>
            </form>
            <button className="close-btn" onClick={() => setShowLogin(false)}>✕</button>
          </div>
        </div>
      )}
    </>
  );
};

export default Navbar;
